import { MarketplaceNameEnum } from '../models/tenant';

export interface MarketplaceMeta {
  shortLabel: string;
  fullLabel: string;
  color: string;
  textColor: string;
}

const META: Record<MarketplaceNameEnum, MarketplaceMeta> = {
  [MarketplaceNameEnum.TimocomMarketplace]: { shortLabel: 'TMC', fullLabel: 'Timocom', color: '#D9E6F2', textColor: '#264F73' },
  [MarketplaceNameEnum.WtransnetMarketplace]: { shortLabel: 'WTN', fullLabel: 'Wtransnet', color: '#F2DADB', textColor: '#7A2A2E' },
  [MarketplaceNameEnum.TransEUMarketplace]: { shortLabel: 'T.EU', fullLabel: 'Trans.eu', color: '#D9EBDE', textColor: '#2E5E3E' },
  [MarketplaceNameEnum.TelerouteMarketplace]: { shortLabel: 'TLR', fullLabel: 'Teleroute', color: '#F6E4CC', textColor: '#7A4E1E' },
  [MarketplaceNameEnum.LKWWalterMarketplace]: { shortLabel: 'LKW', fullLabel: 'LKW Walter', color: '#E3DCEC', textColor: '#4C3B6B' },
};

export const getMarketplaceMeta = (externalPlatform: string | undefined): MarketplaceMeta | null => {
  if (!externalPlatform) return null;
  const known = META[externalPlatform as MarketplaceNameEnum];
  if (known) return known;
  return { shortLabel: '—', fullLabel: externalPlatform, color: '#E0E0E0', textColor: '#555' };
};
